const USER_API_BASE_URL = "/employees";

export const USER_API_ENDPOINTS = {
  ME: `${USER_API_BASE_URL}/me`,
  EMAIL_CHANGE: `${USER_API_BASE_URL}/me/email_change`,
} as const;
